import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';

import AdditionalInformationInput from 'src/pages/WinsDashboard/components/AdditionalInformationInput';
import EmailBodyContent from 'src/pages/WinsDashboard/components/EmailBodyContent';

const ReportEmailPreview = ({ month, year, additionalInformation, onAdditionalInfoChange }) => {
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <EmailBodyContent month={month} year={year} additionalInformation={additionalInformation} />
      <AdditionalInformationInput value={additionalInformation} onChange={onAdditionalInfoChange} />
    </Paper>
  );
};

ReportEmailPreview.propTypes = {
  month: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  additionalInformation: PropTypes.string,
  onAdditionalInfoChange: PropTypes.func.isRequired,
};

export default ReportEmailPreview;
